import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "creating-a-legend"
    }}>{`Creating a legend`}</h1>
    <p><inlineCode parentName="p">{`encoder.getLegendInformation(dataset)`}</inlineCode>{` generates metadata for rendering legend.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const legendInfo = factory
  .create({
    color: {
      type: 'nominal',
      field: 'brand',
      scale: { range: ['red', 'green', 'blue'] },
    },
    radius: { value: 5 },
    shape: { value: 'circle' },
  })
  .getLegendInformation([{ brand: 'Gucci' }, { brand: 'Prada' }]);

// [
//   // legend group information
//   {
//     field: 'brand',
//     type: 'nominal',
//     items: [
//       {
//         input: 'Gucci',
//         output: {
//           color: 'red',
//           radius: 5,
//           shape: 'circle',
//         },
//       },
//       {
//         input: 'Prada',
//         output: {
//           color: 'green',
//           radius: 5,
//           shape: 'circle',
//         },
//       },
//     ],
//   }
// ]
`}</code></pre>
    <p>{`This also works with quantitative fields, with small difference.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const legendInfo = factory
  .create({
    color: {
      type: 'quantitative',
      field: 'price',
      scale: { domain: [0, 20], range: ['#fff', '#f00'] },
    },
    radius: {
      type: 'quantitative',
      field: 'price',
      scale: { domain: [0, 20], range: [0, 10] },
    },
    shape: { value: 'circle' },
  })
  .getLegendInformation();
`}</code></pre>
    <p>{`Unlike the nominal field, `}<inlineCode parentName="p">{`items`}</inlineCode>{` is not included in the output, so you cannot use
`}<inlineCode parentName="p">{`legendInfo[0].items`}</inlineCode>{` directly. Have to create legend items manually from inputs.`}</p>
    <p>{`In the future we can implement logic to infer the appropriate inputs from continuous domain and
output items the same way the nominal field does.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`legendInfo[0].createLegendItems([0, 10, 20]);

// [
//   {
//     input: 0,
//     output: {
//       color: 'rgb(255, 255, 255)',
//       radius: 0,
//       shape: 'circle',
//     },
//   },
//   {
//     input: 10,
//     output: {
//       color: 'rgb(255, 128, 128)',
//       radius: 5,
//       shape: 'circle',
//     },
//   },
//   {
//     input: 20,
//     output: {
//       color: 'rgb(255, 0, 0)',
//       radius: 10,
//       shape: 'circle',
//     },
//   },
// ]
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      